import { HttpAction } from "@megaron/http-service";

export const pitActions = {
  savePitForm: HttpAction({
    path: "/pit/saveForm",
    method: "post",
    requiresAuth: true as const,
  }),
};
